
// const MATCH_HOST = 'http://192.168.0.202:8888/'

module.exports = {

  appAndroidUrl: "https://dict001.oss-cn-shanghai.aliyuncs.com/config/dict.apk",
  appIosUrl: "https://apps.apple.com/us/app/词根词缀词典/id1669969011",
}



// WEBPACK FOOTER //
// ./src/js/constants.js